import { trackEvent } from 'dibs-tracking';

export function trackArticleClick({ source, title }: { source: string; title: string }): void {
    trackEvent({
        category: 'ecommerce',
        action: 'promotion click',
        label: `editorial article: ${source} ${title}`,
    });
}
